/**
*
* <strong>List of API using</strong>
* <ol>
* <li>estapi_assignments_assignment_id_patch</li>
* </ol>
*
*/

import { Component, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subscription } from "rxjs";

@Component({
  selector: 'existingProp',
  templateUrl: './existing-prop.component.html',
  styleUrls: ['../../master-assignment.component.css']
})
export class ExistingPropComponent implements OnDestroy {
  parent: any;
  user: any;
  assignment: any;
  no_of_property: number;
  private subs = new Subscription();
  constructor(public dialogRef: MatDialogRef<ExistingPropComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.parent = this.data.pObj;
    this.user = this.data.user;
    this.no_of_property = this.parent.countProperty(this.user.id);
    this.assignment = this.parent.selectedAssignment;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
  remove(): void {
    this.no_of_property = this.parent.countProperty(this.user.id);
    if (this.no_of_property > 0) return;
    let udata = Object.keys(this.assignment.AssignTo);
    udata.splice(udata.indexOf('' + this.user.id + ''), 1);
    let body = {
      "assigned_to": udata,
      "updated_by": this.parent.api.user_id
    }
    const assgnmentSub = this.parent.api.patchEmsData('assignments/' + this.assignment.id, body)
      .subscribe(data => {
        let assignment = this.parent.fnc.getArrayValue('id', this.parent.selectedAssignment.id, this.parent.masterList);
        if (assignment) {
          this.parent.selectedAssignment = assignment;
          this.parent.getAssignmentById(assignment.id);
        }
        this.parent.notify.notify('User removed from assignment successfully', 'success');
      },
        err => this.parent.notify.notify('Something went wrong', 'error')
      );
    this.subs.add(assgnmentSub);
    this.closeDialog();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
